<template>
  <transition name="slide-up">
    <div v-if="isOpen" class="slideup">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "slideup-mobile",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    ...mapMutations({
      setIsFullscreen: "globals/setIsFullscreen"
    })
  },
  watch: {
    isOpen() {
      this.setIsFullscreen(this.isOpen);
      // this.setHasHeader(!this.isOpen);
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.4s ease-in-out;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(1200px);
}

.slideup {
  position: fixed;
  height: 100vh;
  width: 100%;
  z-index: 50;
  top: 0;
  background-color: white;
}
</style>
